import { render } from "./BottomButtonWrapper.vue?vue&type=template&id=1fdc3d19"
import script from "./BottomButtonWrapper.vue?vue&type=script&lang=js"
export * from "./BottomButtonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__